import { HostElement } from '@stencil/core/internal';
import { FALLBACK_LANGUAGE, LANGUAGE_KEYS } from '../constants/localization';

export const languageLocalization = (element: HTMLElement) => {
  const parent = element && ((element.parentNode as HTMLElement) || ((element as any).host as HTMLElement));
  let langAttributeAvailable = parent && typeof parent.hasAttribute === 'function' && parent.hasAttribute('lang');

  switch (langAttributeAvailable) {
    case true:
      return parent;
    case false:
      return languageLocalization(parent);
    default:
      break;
  }
};

export const getLocalizationLocale = (hostElement: HostElement) => {
  let closestElementWithLangAttr = hostElement.closest('[lang]') as HTMLElement;
  if (closestElementWithLangAttr === null) {
    closestElementWithLangAttr = languageLocalization(hostElement);
  }

  let locale = FALLBACK_LANGUAGE;

  if (closestElementWithLangAttr && closestElementWithLangAttr.lang) {
    const lang = closestElementWithLangAttr.lang.indexOf('-')
      ? closestElementWithLangAttr.lang.split('-')[0]
      : closestElementWithLangAttr.lang;

    if (Object.values(LANGUAGE_KEYS).includes(lang)) locale = lang;
  }

  return locale;
};
